import RoutesMap from "../../route_control/RouteControl"
import {
    ModuleList,
    UserRoleList,
    ActionList,
    AddAction,
    UpdateAction,
    Permission,
    UserPermission,
    CompanyPermission
} from "../../pages/settings"

export const SettingsImport = {
    RoutesMap,
    ModuleList,
    UserRoleList,
    ActionList,
    AddAction,
    UpdateAction,
    Permission,
    UserPermission,
    CompanyPermission,
}